import React, { BaseSyntheticEvent, useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import { MenuItem, Paper, TableRow, TableHead, TableContainer, TableBody, Table } from '@mui/material';
import { StyledTableCell, StyledSelect } from 'components/Common/MUIStyledComponents';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const PREFIX = 'Step3';

const classes = {
  table: `${PREFIX}-table`,
  root: `${PREFIX}-root`,
  select: `${PREFIX}-select`
};

const Root = styled('div')({
  [`& .${classes.table}`]: {
    height: '311px',
    backgroundColor: '#2E3036'
  },
  [`& .${classes.root}`]: {
    height: '311px'
  },
  [`& .${classes.select}`]: {
    width: '100%',
    color: '#F5FAFF',
    fontFamily: 'Inter',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    borderBottom: '1px solid #4A4C51',
    backgroundColor: '#2E3036',
    border: '0px !important',
  },
});

interface IStep3Props {
  selectedTemp: string,
  rows: any[],
  unmatched: any[],
  setUnmatched: any,
  rowData: any[],
  setRowData: any,
  cols: any[],
}

const Step3: React.FC<IStep3Props> = (props: IStep3Props) => {
  const { selectedTemp, rows, setRowData, cols } = props;
  const [ colsArr, setColsArr ] = useState<any>([]);
  const [ loading, setLoading ] = useState(false);


  const valsArrofObjs: any = [];

  useEffect(() => {
    if (selectedTemp === 'generic') {
      setLoading(true);
      const colsArrofObjs: any[] = [];
      cols.forEach((col: any) => {
        let obj = {};
        if (genericProps.includes(col)) {
          obj = {
            prop: col,
            val: col,
          };
        } else {
          obj = {
            prop: undefined,
            val: col,
          };
        }
        colsArrofObjs.push(obj);
      });
      setColsArr(colsArrofObjs);
      const unmatchedObjs = colsArrofObjs.filter((row: any) => {
        return !row.prop;
      });
      if (!unmatchedObjs.length) {
        rows.forEach((row: any, i: number) => {
          Object.keys(row).forEach((key) => {
            const header = colsArrofObjs.find((item: any) => item.val === key);
            const obj = {
              prop: header.prop,
              val: row[key],
              header: key,
              row: i
            };
            valsArrofObjs.push(obj);
          });
        });
        setRowData(valsArrofObjs);
      }
      setLoading(false);
    } else if (selectedTemp === 'import') {
      setLoading(true);
      const colsArrofObjs: any[] = [];
      cols.forEach((col: any) => {
        let obj = {};
        if (expandedProps.includes(col)) {
          obj = {
            prop: col,
            val: col,
          };
        } else {
          obj = {
            prop: undefined,
            val: col,
          };
        }
        colsArrofObjs.push(obj);
      });
      setColsArr(colsArrofObjs);
      const unmatchedObjs = colsArrofObjs.filter((row: any) => {
        return !row.prop;
      });
      if (!unmatchedObjs.length) {
        rows.forEach((row: any, i: number) => {
          Object.keys(row).forEach((key) => {
            const header = colsArrofObjs.find((item: any) => item.val === key);
            const obj = {
              prop: header.prop,
              val: row[key],
              header: key,
              row: i
            };
            valsArrofObjs.push(obj);
          });
        });
        setRowData(valsArrofObjs);
      }
      setLoading(false);
    } else {
      setLoading(true);
      const colsArrofObjs: any[] = [];
      cols.forEach((col: any) => {
        const obj = {
          prop: undefined,
          val: col,
        };
        colsArrofObjs.push(obj);
      });
      setColsArr(colsArrofObjs);
      const unmatchedObjs = colsArrofObjs.filter((row: any) => {
        return !row.prop;
      });
      setLoading(false);
    }
  }, []);

  const selectCustomProp = (e: BaseSyntheticEvent, i: number) => {
    const arr: any = colsArr;
    arr[i].prop = e.target.value;
    setRowData(arr);
    const unmatchedObjs = arr.filter((row: any) => {
      return !row.prop;
    });
    if (!unmatchedObjs.length) {
      rows.forEach((row: any, i: number) => {
        delete row.undefined;
        Object.keys(row).forEach((key) => {
          let obj = {};
          if (key) {
            const header = colsArr.find((item: any) => item.val === key);
            obj = {
              prop: header.prop,
              val: row[key],
              header: key,
              row: i
            };
          }
          valsArrofObjs.push(obj);
        });
      });
      setRowData(valsArrofObjs);
    }
  };

  const genericProps = [ 'Unnecessary / Do not Search', 'Unique Line Item', 'Entity Name (Person / Company / Organization)', 'Entity State', 'Entity Country', 'Commodity Name', 'Commodity HTS Code' ];
  const expandedProps = [ 'Unnecessary / Do not Search', 'Entry Summary Number', 'Consignee Name', 'Consignee Country', 'Importer / Exporter Name', 'Importer / Exporter Country', 'Shipper Name', 'Shipper Country', 'Manufacturer Name', 'Manufacturer Country', 'Vessel Name', 'Vessel Code', 'Commodity Name', 'Commodity HTS Code', 'Brand Name', 'Unloading Port', 'Loading Port' ];
  const customProps = [ 'Unnecessary / Do not Search', 'Entity Name (Person / Company / Organization)', 'Entity State', 'Entity Country', 'Commodity Name', 'Commodity HTS Code', 'Entity City' ];

  const genericOpts = genericProps.map((prop, i) => {
    return (<MenuItem value={prop} key={i}>{prop}</MenuItem>);
  });
  const expandedOpts = expandedProps.map((prop, i) => {
    return (<MenuItem value={prop} key={i}>{prop}</MenuItem>);
  });
  const customOpts = customProps.map((prop, i) => {
    return (<MenuItem value={prop} key={i}>{prop}</MenuItem>);
  });

  const unmatchedTag =
    <div className='props-unmatched-tag'>
      <svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12' fill='none'>
        <path d='M6 3.5C5.86739 3.5 5.74022 3.55268 5.64645 3.64645C5.55268 3.74021 5.5 3.86739 5.5 4V6C5.5 6.13261 5.55268 6.25979 5.64645 6.35355C5.74022 6.44732 5.86739 6.5 6 6.5C6.13261 6.5 6.25979 6.44732 6.35356 6.35355C6.44732 6.25979 6.5 6.13261 6.5 6V4C6.5 3.86739 6.44732 3.74021 6.35356 3.64645C6.25979 3.55268 6.13261 3.5 6 3.5ZM6.46 7.81C6.44906 7.77814 6.43393 7.74787 6.415 7.72L6.355 7.645C6.28469 7.57562 6.1954 7.52862 6.09841 7.50994C6.00141 7.49125 5.90106 7.50171 5.81 7.54C5.74941 7.56532 5.6936 7.60083 5.645 7.645C5.59866 7.69172 5.562 7.74713 5.53712 7.80805C5.51223 7.86897 5.49962 7.9342 5.5 8C5.50079 8.06534 5.51438 8.12989 5.54 8.19C5.56246 8.25205 5.59829 8.3084 5.64495 8.35506C5.6916 8.40172 5.74795 8.43754 5.81 8.46C5.86985 8.48645 5.93457 8.50012 6 8.50012C6.06544 8.50012 6.13015 8.48645 6.19 8.46C6.25205 8.43754 6.3084 8.40172 6.35506 8.35506C6.40172 8.3084 6.43755 8.25205 6.46 8.19C6.48562 8.12989 6.49921 8.06534 6.5 8C6.50246 7.96671 6.50246 7.93329 6.5 7.9C6.49139 7.86812 6.4779 7.83776 6.46 7.81ZM6 1C5.0111 1 4.0444 1.29324 3.22215 1.84265C2.39991 2.39206 1.75904 3.17295 1.3806 4.08658C1.00217 5.00021 0.90315 6.00555 1.09608 6.97545C1.289 7.94536 1.76521 8.83627 2.46447 9.53553C3.16373 10.2348 4.05465 10.711 5.02455 10.9039C5.99446 11.0969 6.99979 10.9978 7.91342 10.6194C8.82705 10.241 9.60794 9.6001 10.1573 8.77785C10.7068 7.95561 11 6.98891 11 6C11 5.34339 10.8707 4.69321 10.6194 4.08658C10.3681 3.47995 9.99983 2.92876 9.53554 2.46447C9.07124 2.00017 8.52005 1.63188 7.91342 1.3806C7.30679 1.12933 6.65661 1 6 1ZM6 10C5.20888 10 4.43552 9.7654 3.77772 9.32588C3.11992 8.88635 2.60723 8.26164 2.30448 7.53073C2.00173 6.79983 1.92252 5.99556 2.07686 5.21964C2.2312 4.44371 2.61216 3.73098 3.17158 3.17157C3.73099 2.61216 4.44372 2.2312 5.21964 2.07686C5.99557 1.92252 6.79983 2.00173 7.53074 2.30448C8.26164 2.60723 8.88635 3.11992 9.32588 3.77772C9.76541 4.43552 10 5.20887 10 6C10 7.06087 9.57858 8.07828 8.82843 8.82843C8.07828 9.57857 7.06087 10 6 10Z' fill='#FDB022' />
      </svg>
      <p className='props-tag-text'>Unmatched</p>
    </div>;

  const matchedTag =
    <div className='props-matched-tag'>
      <svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12' fill='none'>
        <path d='M5.105 7.375C5.15148 7.42186 5.20678 7.45906 5.26771 7.48445C5.32864 7.50983 5.39399 7.5229 5.46 7.5229C5.52601 7.5229 5.59136 7.50983 5.65229 7.48445C5.71322 7.45906 5.76852 7.42186 5.815 7.375L7.855 5.335C7.94915 5.24085 8.00205 5.11315 8.00205 4.98C8.00205 4.84685 7.94915 4.71915 7.855 4.625C7.76085 4.53085 7.63315 4.47795 7.5 4.47795C7.36685 4.47795 7.23915 4.53085 7.145 4.625L5.46 6.315L4.855 5.705C4.76085 5.61085 4.63315 5.55795 4.5 5.55795C4.36685 5.55795 4.23915 5.61085 4.145 5.705C4.05085 5.79915 3.99795 5.92685 3.99795 6.06C3.99795 6.19315 4.05085 6.32085 4.145 6.415L5.105 7.375ZM10.5 1H1.5C1.36739 1 1.24021 1.05268 1.14645 1.14645C1.05268 1.24021 1 1.36739 1 1.5V10.5C1 10.6326 1.05268 10.7598 1.14645 10.8536C1.24021 10.9473 1.36739 11 1.5 11H10.5C10.6326 11 10.7598 10.9473 10.8536 10.8536C10.9473 10.7598 11 10.6326 11 10.5V1.5C11 1.36739 10.9473 1.24021 10.8536 1.14645C10.7598 1.05268 10.6326 1 10.5 1ZM10 10H2V2H10V10Z' fill='#24D05B' />
      </svg>
      <p className='props-tag-text'>Matched</p>
    </div>;

  return (
    (<Root>
      {colsArr.length === 0 ? (
        <div className='spinner-spacer-top'>
          <div className='loader'>Loading...</div>
        </div>
      ) : (
        <TableContainer component={Paper} sx={{ height: '311px' }}>
          <Table className={classes.table} aria-label='customized table'>
            <TableHead>
              <TableRow>
                <StyledTableCell>
                  <div className='props-header-div'>
                    <p className='props-header-text'>Status</p>
                    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
                      <path d='M8.00016 12.6673V3.33398M8.00016 3.33398L3.3335 8.00065M8.00016 3.33398L12.6668 8.00065' stroke='#F5FAFF' strokeWidth='1.33333' strokeLinecap='round' strokeLinejoin='round' />
                    </svg>
                  </div>
                </StyledTableCell>
                <StyledTableCell>
                  <div className='props-header-div'>
                    <p className='props-header-text'>Data Field</p>
                    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
                      <path d='M7.99967 3.33398V12.6673M7.99967 12.6673L12.6663 8.00065M7.99967 12.6673L3.33301 8.00065' stroke='#F5FAFF' strokeWidth='1.33333' strokeLinecap='round' strokeLinejoin='round' />
                    </svg>
                  </div>
                </StyledTableCell>
                <StyledTableCell>
                  <p className='props-header-text'>Property</p>
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody sx={{ height: '311px' }}>
              {colsArr.map((col: any, i: number) => (
                <TableRow key={i}>
                  <StyledTableCell>
                    {!col.prop ? unmatchedTag : matchedTag}
                  </StyledTableCell>
                  <StyledTableCell>{col.val}</StyledTableCell>
                  <StyledTableCell>
                    <StyledSelect
                      value={col.prop}
                      onChange={(e: BaseSyntheticEvent) => selectCustomProp(e, i)}
                      variant='standard'
                      displayEmpty
                      className={classes.select}
                      inputProps={{ 'aria-label': 'Without label' }}
                      IconComponent={KeyboardArrowDownIcon}
                    >
                      {selectedTemp === 'generic' ? (genericOpts) : (selectedTemp === 'import' ? (expandedOpts) : (customOpts))}
                    </StyledSelect>
                  </StyledTableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Root>)
  );
};

export default Step3;
